import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import {useTypedSelector} from "../../../hooks/useTypedSelector";
import React, {Suspense, useContext, useEffect} from "react";
import {UseCasesContext} from "../../../context/useCases";


// Блокированные
const BlockedAdd = React.lazy(() => import('../../pages/blocked/add').then(module => ({ default: module.BlockedAdd })));
const BlockedList = React.lazy(() => import('../../pages/blocked/list').then(module => ({ default: module.BlockedList })));

// Кампании
const Statistics = React.lazy(() => import('../../pages/campaign/statistics').then(module => ({ default: module.Statistics })));
const CampaignForm = React.lazy(() => import('../../pages/campaign/add').then(module => ({ default: module.CampaignForm })));
const CampaignList = React.lazy(() => import('../../pages/campaign/list').then(module => ({ default: module.CampaignList })));
const SummaryList = React.lazy(() => import('../../pages/campaign/summary-list').then(module => ({ default: module.SummaryList })));

// Аудитории
const AudienceAdd = React.lazy(() => import('../../pages/audience/add').then(module => ({ default: module.AudienceAdd })));
const AudienceList = React.lazy(() => import('../../pages/audience/list').then(module => ({ default: module.AudienceList })));
const AudienceItemList = React.lazy(() => import('../../pages/audience/item-list').then(module => ({ default: module.AudienceItemList })));
const AudienceItemAdd = React.lazy(() => import('../../pages/audience/item-add').then(module => ({ default: module.AudienceItemAdd })));

// Каналы
const SegmentAdd = React.lazy(() => import('../../pages/segments/add').then(module => ({ default: module.SegmentAdd })));
const SegmentList = React.lazy(() => import('../../pages/segments/list').then(module => ({ default: module.SegmentlList })));
const SegmentEdit = React.lazy(() => import('../../pages/segments/integration-params-edit').then(module => ({ default: module.IntegrationParamsEdit })));
// Аудио файлы
const AudioAdd = React.lazy(() => import('../../pages/audio/add').then(module => ({ default: module.AudioAdd })));
const AudioList = React.lazy(() => import('../../pages/audio/list').then(module => ({ default: module.AudioList })));

// Авторизация
const Login = React.lazy(() => import('../../pages/auth/login/login').then(module => ({ default: module.Login })));


export const RouterComponent = () => {
    let useCases = useContext(UseCasesContext)

    const login = useTypedSelector(({login}) => {
        return login
    })

    useEffect(() => {
        useCases?.authUseCase.CheckAuthorization()
        setInterval(() => {
            useCases?.authUseCase.CheckAuthorization()
        }, 10000)
    }, [])


    return (<Router basename="/">
            <Routes>
                {login?.authorized ?
                    <>
                        {/* Заблокированные */}
                        <Route path="/blocked/add" element={<Suspense fallback={<>загрузка...</>}><BlockedAdd/></Suspense> }/>
                        <Route path="/blocked" element={<Suspense fallback={<>загрузка...</>}><BlockedList/></Suspense> }/>

                        {/* Компании */}
                        <Route path="/campaign/statistic/:id" element={<Suspense fallback={<>загрузка...</>}><Statistics/></Suspense> }/>
                        <Route path="/campaign/add" element={<Suspense fallback={<>загрузка...</>}><CampaignForm/></Suspense> }/>
                        <Route path="/campaign/:id" element={<Suspense fallback={<>загрузка...</>}><CampaignForm/></Suspense> }/>
                        <Route path="*" element={<Suspense fallback={<>загрузка...</>}><CampaignList/></Suspense> }/>
                        <Route path="/summary" element={<Suspense fallback={<>загрузка...</>}><SummaryList/></Suspense> }/>

                        {/* Каналы */}
                        <Route path="/segment/add" element={<Suspense fallback={<>загрузка...</>}><SegmentAdd /></Suspense> } />
                        <Route path="/segment/edit/:id" element={<Suspense fallback={<>загрузка...</>}><SegmentEdit /></Suspense> } />
                        <Route path="/segment/*" element={<Suspense fallback={<>загрузка...</>}><SegmentList/></Suspense> } />

                        {/* Аудитории */}
                        <Route path="/audience/add" element={<Suspense fallback={<>загрузка...</>}> <AudienceAdd/></Suspense>}/>
                        <Route path="/audience" element={<Suspense fallback={<>загрузка...</>}><AudienceList/></Suspense> }/>
                        <Route path="/audience/item/:id" element={<Suspense fallback={<>загрузка...</>}><AudienceItemList/></Suspense> }/>
                        <Route path="/audience/item/:id/add/" element={<Suspense fallback={<>загрузка...</>}><AudienceItemAdd/></Suspense> }/>

                        {/* Аудио файлы */}
                        <Route path="/audio/add" element={<Suspense fallback={<>загрузка...</>}> <AudioAdd/></Suspense>}/>
                        <Route path="/audio" element={<Suspense fallback={<>загрузка...</>}><AudioList/></Suspense> }/>
                    </>
                    : <>
                        <Route path="*" element={<Suspense fallback={<>загрузка...</>}><Login/></Suspense>}/>
                    </>}
            </Routes>
        </Router>
    )
}